<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p>Annie G. Rogers, Ph.D., is a writer, psychoanalyst, and printmaker. She is Analyst of the School at the Lacanian School of Psychoanalysis, where she teaches and supervises. She was a professor for much of her professional life, serving on faculties at Harvard University and Hampshire College. Dr. Rogers has published short fiction and poetry as well as three non-fiction clinical books: <em>A Shining Affliction: A Story of Harm and Healing in Psychotherapy (1995)</em>; <em>The Unsayable: The Hidden Language of Trauma (2005);</em> and <em>Incandescent Alphabets: Psychosis and the Enigma of Language (2016)</em>. Currently, she makes prints and artist’s books at Zea Mays Printmaking in Florence, Massachusetts, and is compiling a book of poetry, <em>Becoming Bird. </em>She divides her time between Western Massachusetts and Lismore, Ireland.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?25653a90